import { Button, ButtonProps } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"
// import classList from "utils/classNames";
// Component Name - Button
// Component Used For - Click events and Mutation Hits
// Author - Malik Bagwala

/*
Props
1. style - a style object to override default styles
2. round - ability to make the button a circle (only works when there are no childred or text else it is converted to a 'pill')
3. dark - changes the theme of the button to dark

8. error - this is the custom error message which is displayed on the input a few features like
   helperText and intent change to danger whenever there is an error

Blueprint
Component - Button

Link to Documentation -
https://blueprintjs.com/docs/#core/components/button
*/
export interface CustomButtonProps extends ButtonProps {
  id?: string
  round?: boolean
  pill?: boolean
  text?: string | React.FC
  style?: React.CSSProperties | undefined
  className?: string
  large?: boolean
  outline?: boolean
  dark?: boolean
  big?: boolean
  minimal?: boolean
  loading?: boolean
  type?: "button" | "submit" | "reset" | undefined
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  unstyled?: boolean
  relative?: boolean
}
const CustomButton = ({
  round,
  children,
  outline,
  pill,
  text,
  style,
  className,
  large,
  dark,
  big,
  minimal,
  onClick,
  loading,
  relative = true,
  unstyled,
  ...buttonProps
}: CustomButtonProps) => {
  let borderRadius: React.ReactText = 4
  if (round && !text && !children) {
    borderRadius = "50%"
  } else if (pill) {
    borderRadius = large ? 20 : 15
  }

  return (
    <Button
      style={
        unstyled
          ? style
          : {
              borderRadius,
              height: big ? "2.3rem" : undefined,
              boxShadow: "none",
              ...style,
            }
      }
      text={text}
      large={large}
      loading={loading}
      {...buttonProps}
      className={classNames(
        unstyled ? null : "vt-custom-button",
        relative && "relative",
        unstyled
          ? null
          : {
              "vt-button-dark": dark,
              "vt-button-outline": outline,
              "vt-button-minimal": minimal,
              "vt-button-loading": loading,
            },
        className
      )}
      onClick={onClick}
      minimal={minimal}
    >
      {children}
    </Button>
  )
}

export default CustomButton
